import { createSlice } from '@reduxjs/toolkit'
const managePredictorToolsSlice = createSlice({
  name: 'predictorTools',
  initialState: {
    filterData: null,
    listingData: null,
    filterLoading: false,
    listingLoading: false,
    filterError: null,
    listingError: null,
    basicDetailDropdownLoading: false,
    basicDetailDropdownData: null,
    basicDetailDropdownError: null,

    //tools name dropdown data
    predictorToolNameLoading: false,
    predictorToolNameData: null,
    predictorToolNameError: null,

    //domain dropdown data
    predictorToolDomainLoading: false,
    predictorToolDomainData: null,
    predictorToolDomainError: null,

    //tools dropdown data
    predictorToolTypeLoading: false,
    predictorToolTypeData: null,
    predictorToolTypeError: null,

    //author dropdown data
    predictorToolAuthorLoading: false,
    predictorToolAuthorData: null,
    predictorToolAuthorError: null,

    //exam dropdown data
    predictorExamDropdownLoading: false,
    predictorExamDropdownData: null,
    predictorExamDropdownError: null,

    //get basic detail data
    basicDetailLoading: false,
    basicDetailData: null,
    basicDetailError: null,

    //post basic detail data
    postBasicDetailDataLoading: false,
    postBasicDetailData: null,
    postBasicDetailDataError: null,

    //get input page detail data
    inputDetailLoading: false,
    inputDetailData: null,
    inputDetailError: null,

    //post input page detail data
    postInputDetailDataLoading: false,
    postInputDetailData: null,
    postInputDetailError: null,

    //get input page tool content
    inputToolContentDataLoading: false,
    inputToolContentData: null,
    inputToolContentError: null,

    //post input page tool content
    postInputToolContentDataLoading: false,
    postInputToolContentData: null,
    postInputToolContentError: null,

    //get input page faq content
    inputPageFaqDataLoading: false,
    inputPageFaqData: null,
    inputPageFaqError: null,

    //post input page faq content
    postInputPageFaqDataLoading: false,
    postInputPageFaqData: null,
    postInputPageFaqError: null,

    //get result page faq content
    resultPageLoading: false,
    resultPageData: null,
    resultPageError: null,

    //post result page faq content
    postResultPageDataLoading: false,
    postResultPageData: null,
    postResultPageError: null,

    basicFormMessage: null,

  },
  reducers: {
    loadingFilterData(state) {
      state.filterLoading = true
      state.filterError = null
    },
    fetchFilterDataSuccess(state, action) {
      return {
        ...state,
        filterData: action.payload.data,
        filterLoading: false,
        filterError: null,
      }
    },
    fetchFilterDataError(state, action) {
      state.filterError = action.payload
      state.filterLoading = false
    },
    loadingListingData(state) {
      state.listingLoading = true
      state.listingError = null
    },
    fetchListingDataSuccess(state, action) {
      state.listingLoading = false
      state.listingData = action.payload
      state.listingError = null
    },
    fetchListingDataError(state, action) {
      state.listingLoading = false
      state.listingError = action.payload
    },

    // basic detail dropdown list
    loadingBasicDetailDropdownList(state) {
      state.basicDetailDropdownLoading = true
      state.basicDetailDropdownError = null
    },
    fetchBasicDetailDropdownListSuccess(state, action) {
      return {
        ...state,
        basicDetailDropdownData: action.payload.data,
        basicDetailDropdownLoading: false,
        basicDetailDropdownError: null,
      }
    },
    fetchBasicDetailDropdownListError(state, action) {
      ; (state.basicDetailDropdownError = action.payload),
        (state.basicDetailDropdownLoading = false)
    },
    // tool type dropdown
    getPredictorToolTypeLoading(state, action) {
      return {
        ...state,
        predictorToolTypeLoading: true,
      };
    },
    getPredictorToolTypeSuccess(state, action) {
      return {
        ...state,
        predictorToolTypeLoading: false,
        predictorToolTypeData: action.payload,
      };
    },
    getPredictorToolTypeFailure(state, action) {
      return {
        ...state,
        predictorToolTypeLoading: false,
        predictorToolTypeError: action.payload,
      };
    },
    clearPredictorToolTypeResponse(state, action) {
      return {
        ...state,
        predictorToolTypeData: null,
      };
    },

     // tool name dropdown
     getPredictorToolNameLoading(state, action) {
      return {
        ...state,
        predictorToolNameLoading: true,
      };
    },
    getPredictorToolNameSuccess(state, action) {
      return {
        ...state,
        predictorToolNameLoading: false,
        predictorToolNameData: action.payload,
      };
    },
    getPredictorToolNameFailure(state, action) {
      return {
        ...state,
        predictorToolNameLoading: false,
        predictorToolNameError: action.payload,
      };
    },
    clearPredictorToolNameResponse(state, action) {
      return {
        ...state,
        predictorToolNameData: null,
      };
    },

     // domain dropdown
     getPredictorToolDomainLoading(state, action) {
      return {
        ...state,
        predictorToolDomainLoading: true,
      };
    },
    getPredictorToolDomainSuccess(state, action) {
      return {
        ...state,
        predictorToolDomainLoading: false,
        predictorToolDomainData: action.payload,
      };
    },
    getPredictorToolDomainFailure(state, action) {
      return {
        ...state,
        predictorToolDomainLoading: false,
        predictorToolDomainError: action.payload,
      };
    },
    clearPredictorToolDomainResponse(state, action) {
      return {
        ...state,
        predictorToolDomainData: null,
      };
    },
      // author dropdown
      getPredictorToolAuthorLoading(state, action) {
        return {
          ...state,
          predictorToolAuthorLoading: true,
        };
      },
      getPredictorToolAuthorSuccess(state, action) {
        return {
          ...state,
          predictorToolAuthorLoading: false,
          predictorToolAuthorData: action.payload,
        };
      },
      getPredictorToolAuthorFailure(state, action) {
        return {
          ...state,
          predictorToolAuthorLoading: false,
          predictorToolAuthorError: action.payload,
        };
      },
      clearPredictorToolAuthorResponse(state, action) {
        return {
          ...state,
          predictorToolAuthorData: null,
        };
      },

    //exam dropdown 

    getPredictorExamDropdownLoading(state, action) {
      return {
        ...state,
        predictorExamDropdownLoading: true,
      };
    },
    getPredictorExamDropdownSuccess(state, action) {
      return {
        ...state,
        predictorExamDropdownLoading: false,
        predictorExamDropdownData: action.payload,
      };
    },
    getPredictorExamDropdownFailure(state, action) {
      return {
        ...state,
        predictorExamDropdownLoading: false,
        predictorExamDropdownError: action.payload,
      };
    },
    clearPredictorExamDropdownResponse(state, action) {
      return {
        ...state,
        predictorExamDropdownData: null,
      };
    },


    // get basic detail
    getBasicDetailLoading(state, action) {
      return {
        ...state,
        basicDetailLoading: true,
      };
    },
    getBasicDetailSuccess(state, action) {
      return {
        ...state,
        basicDetailLoading: false,
        basicDetailData: action.payload,
      };
    },
    getBasicDetailFailure(state, action) {
      return {
        ...state,
        basicDetailLoading: false,
        basicDetailError: action.payload,
      };
    },
    clearGetBasicDetailResponse(state, action) {
      return {
        ...state,
        basicDetailData: null,
      };
    },

    // post basic detail
    postBasicDetailLoading(state, action) {
      return {
        ...state,
        postBasicDetailDataLoading: true,
      };
    },
    postBasicDetailSuccess(state, action) {
      return {
        ...state,
        postBasicDetailDataLoading: false,
        postBasicDetailData: action.payload,
        basicFormMessage: "Data Added Successfuly"
      };
    },
    postBasicDetailFailure(state, action) {
      return {
        ...state,
        postBasicDetailDataLoading: false,
        postBasicDetailDataError: action.payload,
        basicFormMessage: "Something went wrong"
      };
    },
    clearPostBasicDetailMessageResponse(state, action) {
      return {
        ...state,
        basicFormMessage: null,
      };
    },
    clearPostBasicDetailResponse(state, action) {
      return {
        ...state,
        postBasicDetailData: null,
        postBasicDetailDataError: null,
      };
    },
    // get input detail page
    getInputDetailLoading(state, action) {
      return {
        ...state,
        inputDetailLoading: true,
      };
    },
    getInputDetailSuccess(state, action) {
      return {
        ...state,
        inputDetailLoading: false,
        inputDetailData: action.payload,
      };
    },
    getInputDetailFailure(state, action) {
      return {
        ...state,
        inputDetailLoading: false,
        inputDetailError: action.payload,
      };
    },
    clearInputDetailResponse(state, action) {
      return {
        ...state,
        inputDetailData: null,
      };
    },

    // post input detail page

    postInputDetailLoading(state, action) {
      return {
        ...state,
        postInputDetailDataLoading: true,
      };
    },
    postInputDetailSuccess(state, action) {
      return {
        ...state,
        postInputDetailDataLoading: false,
        postInputDetailData: action.payload,
      };
    },
    postInputDetailFailure(state, action) {
      return {
        ...state,
        postInputDetailDataLoading: false,
        postInputDetailError: action.payload,
      };
    },
    clearPostInputDetailResponse(state, action) {
      return {
        ...state,
        postInputDetailData: null,
        postInputDetailError: null,
      };
    },

    //get input page tool content
    getInputToolContentLoading(state, action) {
      return {
        ...state,
        inputToolContentDataLoading: true,
      };
    },
    getInputToolContentSuccess(state, action) {
      return {
        ...state,
        inputToolContentDataLoading: false,
        inputToolContentData: action.payload,
      };
    },
    getInputToolContentFailure(state, action) {
      return {
        ...state,
        inputToolContentDataLoading: false,
        inputToolContentError: action.payload,
      };
    },
    clearInputToolContentResponse(state, action) {
      return {
        ...state,
        inputToolContentData: null,
        inputToolContentError: null,
      };
    },

    //post input page tool content

    postInputToolContentLoading(state, action) {
      return {
        ...state,
        postInputToolContentDataLoading: true,
      };
    },
    postInputToolContentSuccess(state, action) {
      return {
        ...state,
        postInputToolContentDataLoading: false,
        postInputToolContentData: action.payload,
      };
    },
    postInputToolContentFailure(state, action) {
      return {
        ...state,
        postInputToolContentDataLoading: false,
        postInputToolContentError: action.payload,
      };
    },
    clearPostInputToolContentResponse(state, action) {
      return {
        ...state,
        postInputToolContentData: null,
        postInputToolContentError: null,
      };
    },

    //get input page faq
    getInputPageFaqLoading(state, action) {
      return {
        ...state,
        inputPageFaqDataLoading: true,
      };
    },
    getInputPageFaqSuccess(state, action) {
      return {
        ...state,
        inputPageFaqDataLoading: false,
        inputPageFaqData: action.payload,
      };
    },
    getInputPageFaqFailure(state, action) {
      return {
        ...state,
        inputPageFaqDataLoading: false,
        inputPageFaqError: action.payload,
      };
    },
    clearInputPageFaqResponse(state, action) {
      return {
        ...state,
        inputPageFaqData: null,
        inputPageFaqError: null,
      };
    },

    //post input page faq content
    postInputPageFaqLoading(state, action) {
      return {
        ...state,
        postInputPageFaqDataLoading: true,
      };
    },
    postInputPageFaqSuccess(state, action) {
      return {
        ...state,
        postInputPageFaqDataLoading: false,
        postInputPageFaqData: action.payload,
      };
    },
    postInputPageFaqFailure(state, action) {
      return {
        ...state,
        postInputPageFaqDataLoading: false,
        postInputPageFaqError: action.payload,
      };
    },
    clearPostInputPageFaqResponse(state, action) {
      return {
        ...state,
        postInputPageFaqData: null,
        postInputPageFaqError: null,
      };
    },

    //get result page 
    getResultPageLoading(state, action) {
      return {
        ...state,
        resultPageLoading: true,
      };
    },
    getResultPageSuccess(state, action) {
      return {
        ...state,
        resultPageLoading: false,
        resultPageData: action.payload,
      };
    },
    getResultPageFailure(state, action) {
      return {
        ...state,
        resultPageLoading: false,
        resultPageError: action.payload,
      };
    },
    clearResultPageResponse(state, action) {
      return {
        ...state,
        resultPageData: null,
        resultPageError: null,
      };
    },

    //post result page 
    postResultPageLoading(state, action) {
      return {
        ...state,
        postResultPageDataLoading: true,
      };
    },
    postResultPageSuccess(state, action) {
      return {
        ...state,
        postResultPageDataLoading: false,
        postResultPageData: action.payload,
      };
    },
    postResultPageFailure(state, action) {
      return {
        ...state,
        postResultPageDataLoading: false,
        postResultPageError: action.payload,
      };
    },
    clearPostResultPageResponse(state, action) {
      return {
        ...state,
        postResultPageData: null,
        postResultPageError: null,
      };
    },

  },
})

export const {
  loadingFilterData,
  fetchFilterDataSuccess,
  fetchFilterDataError,
  loadingListingData,
  fetchListingDataSuccess,
  fetchListingDataError,
  loadingBasicDetailDropdownList,
  fetchBasicDetailDropdownListSuccess,
  fetchBasicDetailDropdownListError,

  getPredictorToolTypeLoading,
  getPredictorToolTypeSuccess,
  getPredictorToolTypeFailure,
  clearPredictorToolTypeResponse,

  getPredictorToolNameLoading,
  getPredictorToolNameSuccess,
  getPredictorToolNameFailure,
  clearPredictorToolNameResponse,

  getPredictorToolDomainLoading,
  getPredictorToolDomainSuccess,
  getPredictorToolDomainFailure,
  clearPredictorToolDomainResponse,


  getPredictorExamDropdownLoading,
  getPredictorExamDropdownSuccess,
  getPredictorExamDropdownFailure,
  clearPredictorExamDropdownResponse,

  getBasicDetailLoading,
  getBasicDetailSuccess,
  getBasicDetailFailure,
  clearGetBasicDetailResponse,

  postBasicDetailLoading,
  postBasicDetailSuccess,
  postBasicDetailFailure,
  clearPostBasicDetailResponse,

  getInputDetailLoading,
  getInputDetailSuccess,
  getInputDetailFailure,
  clearInputDetailResponse,

  postInputDetailLoading,
  postInputDetailSuccess,
  postInputDetailFailure,
  clearPostInputDetailResponse,

  getInputToolContentLoading,
  getInputToolContentSuccess,
  getInputToolContentFailure,
  clearInputToolContentResponse,

  postInputToolContentLoading,
  postInputToolContentSuccess,
  postInputToolContentFailure,
  clearPostInputToolContentResponse,

  getInputPageFaqLoading,
  getInputPageFaqSuccess,
  getInputPageFaqFailure,
  clearInputPageFaqResponse,

  postInputPageFaqLoading,
  postInputPageFaqSuccess,
  postInputPageFaqFailure,
  clearPostInputPageFaqResponse,

  getResultPageLoading,
  getResultPageSuccess,
  getResultPageFailure,
  clearResultPageResponse,

  postResultPageLoading,
  postResultPageSuccess,
  postResultPageFailure,
  clearPostResultPageResponse,

  clearPostBasicDetailMessageResponse,

  getPredictorToolAuthorLoading,
  getPredictorToolAuthorSuccess,
  getPredictorToolAuthorFailure,
  clearPredictorToolAuthorResponse,


} = managePredictorToolsSlice.actions

export default managePredictorToolsSlice.reducer
